/**
 * See apps/server/src/main/resources/json/webError.json for enum values.
 * json2ts does not generate runtime constants, only type information, so the
 * enum is redefined here.
 */
export enum ErrorCode {
  EMAIL_ALREADY_REGISTERED = "EMAIL_ALREADY_REGISTERED",
  PHONE_ALREADY_REGISTERED = "PHONE_ALREADY_REGISTERED",
}
